const _Misc = require("util/Misc");
const _Event = require("util/Event");

let _History = {
    init : function() {
        _History.supported = (window.history && history.pushState);
        if(_History.supported) {
            _History.currentLocation = _History.getLocation();
            _Misc.callEvery(_History.checkHistory, 500);
            _Event.tap("a", _History.onATap);
            _History.updatePaths();
        }
    },

    onATap : function(e){
        let $a = $(e.currentTarget);
        let newPath = $a.attr("href");if(newPath && newPath.indexOf("www") < 0 && newPath && newPath.indexOf("http") < 0 && newPath.indexOf("mailto") < 0){
            e.preventDefault();
            _History.pushState(newPath);
        }
    },

    pushState : function(newUrl){
        if(_History.getLocation() !== newUrl){
            history.pushState(null, null, newUrl);
        }
    },

    forceState : function(newUrl){
        if(_History.getLocation() !== newUrl){
            history.replaceState(null, null, newUrl);
        }
    },

    checkHistory : function(){
        if(_History.currentLocation !== _History.getLocation()){
            _History.currentLocation = _History.getLocation();
            _History.updatePaths();
            _History.historyChangedHandler();
        }
    },

    historyChangedHandler : function(){
        //console.log("History has changed to: " + _History.getLocation());
    },

    updatePaths : function(){
        _History.l1 = _History.getLevelPath(0).toLowerCase();
        _History.l2 = _History.getLevelPath(1).toLowerCase();
        _History.l3 = _History.getLevelPath(2).toLowerCase();
        _History.l4 = _History.getLevelPath(3).toLowerCase();
        _History.l5 = _History.getLevelPath(4).toLowerCase();
        if(_History.pathCBs){
            let n = _History.pathCBs.length;
            for(let i = 0; i < n; i++){
                _History.pathCBs[i](_History.l1, _History.l2, _History.l3, _History.l4, _History.l5);
            }
        }
    },

    getPaths : function(){
        var pathnames = window.location.pathname.toLowerCase();
        if(pathnames.charAt(0) === "/")
            pathnames = pathnames.slice(1);
        return pathnames.split( '/' );
    },

    getLocation : function(){
        var loc = window.location.pathname.toLowerCase();
        if(loc.charAt(0) === "/")
            loc = loc.slice(1);
        return loc;
    },

    getLevelPath : function(level){
        var path = _History.getPaths()[level];
        if(path)
            return path.toLowerCase();
        return "";
    },

    addPathWatcher : function(cb){
        if(!_History.pathCBs)
            _History.pathCBs = [];
        _History.pathCBs.push(cb);
    },

    pushPrev(altUrl){
        if(this.prevDest){
            window.location.href = this.prevDest;
        }
        else{
            this.pushState(altUrl);
        }
    }
};

module.exports = _History;


// WEBPACK FOOTER //
// ./src/control/base/History.js